import { useState, useEffect } from "react";
import styled from "styled-components";
import { Input } from "./prtnr";

const ModalContainer = styled.div`
  width: 960px;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Padding-Normal, 16px);
  align-self: stretch;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Title = styled.h2`
  color: var(--Color-Text-Text, #212543);
  text-align: center;

  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const Text = styled.p`
  color: var(--Color-Text-Text, #212543);
  text-align: center;

  font-family: Montserrat;
  font-size: var(--Fonts-P4, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
`;

const Highlight = styled.span`
  color: var(--Color-Brand-Secoundary, #6162c5);

  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const InputLabel = styled.label`
  color: var(--Color-Text-Gray, #64748b);
  text-align: center;

  font-family: Montserrat;
  font-size: var(--Fonts-Label, 12px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  flex: 1 0 0;
`;

const ShareLink = styled.label`
  text-align: center;

  color: var(--Color-Text-Text, #212543);

  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.16px;
  flex: 1 0 0;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 518px;
  gap: 16px;
  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const IconsRow = styled.div`
  display: flex;
  justify-content: center;
  width: 518px;
  gap: 16px;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const RootWrapperShareModal = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ShareImage = styled.img`
  width: 174px;
  height: 174px;
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
  aspect-ratio: 1/1;
`;

const Button = styled.button`
  display: flex;
  height: 42px;
  padding: var(--Padding-Small, 8px) var(--Padding-Normal, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--Padding-Small, 8px);
  border-radius: var(--sizing-sizing-05, 8px);
  border: none;
  background: var(--buttons-primary-default-background, #5f5fc4);
  color: var(--Color-Text-White, #fff);
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const ShareVendorModal = ({ onClose, vendor }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [shareLink, setShareLink] = useState("");

  useEffect(() => {
    const currentUrl = window.location.href;
    setShareLink(currentUrl);
  }, []);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = shareLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  const handleWhatsAppShare = () => {
    const message = encodeURIComponent(
      `Check out ${vendor?.company_name} on Paartner! Earn £${vendor?.reward} for successful referrals. ${shareLink}`
    );
    window.open(`https://wa.me/?text=${message}`, "_blank");
  };

  const handleLinkedInShare = () => {
    const url = encodeURIComponent(shareLink);
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    window.open(shareUrl, "_blank");
  };

  const handleEmailShare = () => {
    const subject = `Check out ${vendor?.company_name} on Paartner`;
    const body = `I wanted to share this great vendor opportunity with you!

${vendor?.company_name} - ${vendor?.short_description}

Reward: £${vendor?.reward}

${shareLink}

Join Paartner to start earning rewards through referrals!
`;

    try {
      const mailtoLink = `mailto:?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;

      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );

      if (isMobile) {
        window.location.href = mailtoLink;
      } else {
        const emailWindow = window.open(mailtoLink, "_self");
        if (!emailWindow) {
          window.location.href = mailtoLink;
        }
      }
    } catch (error) {
      const emailContent = `Subject: ${subject}\n\n${body}`;
      navigator.clipboard
        .writeText(emailContent)
        .then(() => {
          alert(
            "Email content copied to clipboard! You can paste it into your email client."
          );
        })
        .catch(() => {
          alert(
            `Please copy this email content:\n\nSubject: ${subject}\n\n${body}`
          );
        });
    }
  };

  return (
    <RootWrapperShareModal>
      <Overlay>
        <ModalContainer>
          <ShareImage src="https://d3nakrlcog1u3z.cloudfront.net/1758520753877-image 19.png" />
          <Title>
            Share <Highlight>{vendor?.company_name}</Highlight>
          </Title>
          <Text>
            Share this vendor opportunity with your network and help them
            discover great referral rewards!
          </Text>

          <ButtonRow>
            <Input
              label={
                <InputLabel>
                  <p>Share this vendor page with your network.</p>
                </InputLabel>
              }
              value={shareLink}
              readOnly
            />
            <Button onClick={handleCopyLink}>
              {copySuccess ? "Copied!" : "Copy"}
            </Button>
          </ButtonRow>

          <ButtonRow>
            <ShareLink>Or share link via</ShareLink>
          </ButtonRow>

          <IconsRow>
            <Icon
              src="https://d3nakrlcog1u3z.cloudfront.net/1758521592112-image 24.png"
              alt="WhatsApp"
              onClick={handleWhatsAppShare}
              style={{ cursor: "pointer" }}
            />
            <Icon
              src="https://d3nakrlcog1u3z.cloudfront.net/1758521592194-image 25.png"
              alt="Email"
              onClick={handleEmailShare}
              style={{ cursor: "pointer" }}
            />
            <Icon
              src="https://d3nakrlcog1u3z.cloudfront.net/1758521592227-image 27.png"
              alt="LinkedIn"
              onClick={handleLinkedInShare}
              style={{ cursor: "pointer" }}
            />
          </IconsRow>
        </ModalContainer>
      </Overlay>
    </RootWrapperShareModal>
  );
};

export default ShareVendorModal;
